/** Maps staff detail KPI titles to analytics i18n keys. */
export const TEAM_KPI_TITLE_KEYS: Record<string, string> = {
  "Tasks completed": "team.table.tasksCompleted",
  "Tasks cancelled": "team.table.tasksCancelled",
  "Avg time on task": "team.table.avgTimeOnTask",
  Delays: "team.table.delays",
  "Day off": "team.table.dayOff",
};
